import Dialog from 'Components/UI/Dialog';

export default Dialog;
